export default __webpack_public_path__ + "6e2ff4b.png";